const promiseRetry = <T>(fn: () => Promise<T>, retriesLeft = 5, interval = 1000): Promise<T> =>
    new Promise((resolve, reject) =>
        fn()
            .then(resolve)
            .catch((error) => {
                if (retriesLeft === 0) {
                    reject(error);
                    return;
                }
                setTimeout(() => {
                    promiseRetry(fn, retriesLeft - 1, interval).then(resolve, reject);
                }, interval);
            })
    );

export default promiseRetry;
